<template>
  <div class="card shadow mb-4">
    <!-- Card Body -->
    <div class="card-body">
      <div class="row">
        <div v-if="user_is_admin" class="col-6">
          <label class="control-label">Producer:</label>
          <select v-model="selected_producerId" class="form-control mb-3">
            <option value="">-</option>
            <option v-for="producer in producers" v-bind:key="producer.id || producer._id" v-bind:value="producer.id || producer._id">
              {{ producer.username }}
            </option>
          </select>
        </div>
        <div v-if="user_is_admin || current_page=='Substations'" class="col-6">
          <label class="control-label">
            <span v-if="current_page!='Substations'">{{ $t('Device') }}: </span>
            <span v-else>{{ $t('Transformation_station') }}: </span>
          </label>
          <select v-model="selected_group" class="form-control mb-3">
            <option>-</option>
            <option v-for="group in groups" v-bind:key="group._id" v-bind:value="group._id">
              {{ group.name }}
            </option>
          </select>
        </div>
        <!-- Period of time -->
        <div v-if="current_page == 'Substations'" class="col-6">
          <label class="control-label"><span >{{ $t('Period_of_time') }}:</span></label>
          <select v-model="range" class="form-control" id="select-range">
            <option value="day" selected>{{ $t('Day') }}</option>
            <option value="week">{{ $t('Week') }}</option>
            <option value="month">{{ $t('Month') }}</option>
          </select>
        </div>
        <!-- Date -->
        <div v-if="current_page == 'Substations'" class="col-6">
          <label class="control-label">
            <span >{{ $t('Date') }}: </span>
          </label>
          <div class="input-group date" :key="'datetimepicker'">
            <label class="input-group-addon btn" style="cursor:default!important" v-bind:for="'datetime-picker'">
              <span class="fa fa-calendar"></span>
            </label>
            <input type="text" readonly class="form-control datetimepicker-input" value="" :id="'datetime-picker'" data-toggle="datetimepicker" :data-target="'#datetime-picker'"/>
          </div>
        </div>
        <!-- View -->
        <div v-if="current_page == 'Substations'" :class="{'col-12': user_is_admin, 'col-6': !user_is_admin}">  
          <label class="control-label"><span style="visibility:hidden;">Ver</span></label>
          <button @click="request_data" class="btn btn-block btn-primary d-block">{{ $t('View')}}</button>
        </div>
      </div>

      <h6 v-if ="current_page != 'Substations'" class="font-weight-bold">
        {{ $t('View_data_from') }}: 
        <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="$t('home_tooltip_select_period')"></i>
      </h6>

      <div v-if ="current_page != 'Substations'" id="Escala" class="col-12 mt-3"> 
        <div class="row">
          <div class="col-12 col-sm-6 col-xl-3 mt-1">
            <button @click="rangeBtnHandler('hour')" class="btn btn-sm btn-block btn-range range" v-bind:class="{active: range == 'hour'}" data-id="1 hora" id="1-hour">{{ $t('Last_hour') }}</button>
          </div>
          <div class="col-12 col-sm-6 col-xl-3 mt-1">
            <button @click="rangeBtnHandler('day')" class="btn btn-sm btn-block btn-range range" v-bind:class="{active: range == 'day'}" data-id="24 horas" id="24-hours">{{ $t('Last_24_hours') }}<span v-if="has_forecast && user_is_admin && current_page == 'Home' && total_group_id==this.selected_group"> (contém Forecast)</span></button>
          </div>
          <div class="col-12 col-sm-6 col-xl-3 mt-1">
            <button @click="rangeBtnHandler('week')" class="btn btn-sm btn-block btn-range range" v-bind:class="{active: range == 'week'}" data-id="7 dias" id="7-days">{{ $t('Last_7_days') }}<span v-if="has_forecast && user_is_admin && current_page == 'Home' && total_group_id==this.selected_group"> (contém Forecast)</span></button>
          </div>
          <div class="col-12 col-sm-6 col-xl-3 mt-1">
            <button @click="rangeBtnHandler('month')" class="btn btn-sm btn-block btn-range range" v-bind:class="{active: range == 'month'}" data-id="30 dias" id="30-days">{{ $t('Last_30_days') }}<span v-if="has_forecast && user_is_admin && current_page == 'Home' && total_group_id==this.selected_group"> (contém Forecast)</span></button>
          </div>
        </div>
        <!-- <div v-if="has_forecast && user_is_admin && current_page == 'Home'" class="row">
          <div class="col-12 col-sm-6 col-xl-3 mt-1">
            <button @click="rangeBtnHandler('next_hours')" class="btn btn-sm btn-block btn-range range" v-bind:class="{active: range == 'next_hours'}" data-id="Próximas horas" id="next-hours">{{ $t('Next_hours') }} (contém Forecast)</button>
          </div>
        </div> -->
      </div>

    </div>
    <!-- End Card Body -->
  </div>
</template>

<script>
import '../assets/vendor/datetimepicker/js/bootstrap-datetimepicker.min.js';
export default {
  name: 'SelectDataRange',
  data: function(){
    return {
      range: null,
      selected_producerId: null,
      selected_group: null,
      groups: null,
      requestInterval: null,
      minDate: "2017/01/01",
      group: {},
    }
  },
  mounted: function(){
    if (this.current_page != "Substations") this.range = 'hour'
    else this.range = 'day'
    this.$store.dispatch('setRange', this.range)
    if (!this.$store.getters.user_isAdmin) {
      this.selected_producerId = this.$store.getters.user_id
    }

    if (this.current_page == 'Substations') {
      const timezone = this.$store.getters.timezone
      const datetime_picker_options = {
        format: 'DD/MM/YYYY',
        viewMode: 'days',
        ignoreReadonly: true,
        extraFormats: ['DD/MM/YYYY - DD/MM/YYYY'],
        locale: moment.locale(this.current_lang, {
          week: { dow: 1 }
        }),
        useCurrent: false,
        debug: false,
        minDate: "2017/01/01",
        maxDate: moment().millisecond(59).second(59).minute(59).hour(23),
        icons: {
          previous: "fas fa-chevron-left",
          next: "fas fa-chevron-right"
        }
      }

      $(`#datetime-picker`).datetimepicker(datetime_picker_options)
      $(`#datetime-picker`).data("DateTimePicker").date(new Date())
      const self = this
      
      // ON DATEPICKER CHANGE
      $(`#datetime-picker`).on('dp.change', function (e) {
        if (self.range == "week") {
          const datetime = $(`#datetime-picker`).data("DateTimePicker").date()
          if (datetime) {
            let end = null
            let start = null
            if (datetime.day() == 0) { // if Sunday, pick last monday (-6) and add 6 days
              start = moment.tz(datetime.day(-6).format("YYYY-MM-DD"), timezone);
              end = start.clone().add(6, 'days')
            }
            else { // else any other day, pick this monday (1) and add 6 days
              start = moment.tz(datetime.day(1).format("YYYY-MM-DD"), timezone);
              end = start.clone().add(6, 'days')
            }
            $(this).val(start.format("DD/MM/YYYY")+" - "+end.format("DD/MM/YYYY"))
          }
          $(".active.day").parent().css('background-color', '#89b43f')
          $(".active.day").parent().find('td').addClass('active').css('background-color', '#89b43f')
        }
      })
      
      // ON DATEPICKER SHOW
      $(`#datetime-picker`).on('dp.show', function (e) {
        $(".active.day").css('background-color', '#89b43f')
        $(".active.month").css('background-color', '#89b43f')
        $(".active.year").css('background-color', '#89b43f')
        if (self.range == "week") {
          const datetime = $(`#datetime-picker`).data("DateTimePicker").date()
          if (datetime) {
            let end = null
            let start = null
            if (datetime.day() == 0) { // if Sunday, pick last monday (-6) and add 6 days
              start = moment.tz(datetime.day(-6).format("YYYY-MM-DD"), timezone);
              end = start.clone().add(6, 'days')
            }
            else { // else any other day, pick this monday (1) and add 6 days
              start = moment.tz(datetime.day(1).format("YYYY-MM-DD"), timezone);
              end = start.clone().add(6, 'days')
            }
            $(this).val(start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY"))
          }
          $(".active.day").parent().css('background-color', '#89b43f')
          $(".active.day").parent().find('td').addClass('active').css('background-color', '#89b43f')
        }
      })

      // ON DATEPICKER UPDATE
      $(`#datetime-picker`).on('dp.update', function (e) {
        $(".active.day").css('background-color', '#89b43f');
        $(".active.month").css('background-color', '#89b43f');
        $(".active.year").css('background-color', '#89b43f');
        if (self.range == "week") {
          $(".active.day").parent().css('background-color', '#89b43f');
          $(".active.day").parent().find('td').addClass('active').css('background-color', '#89b43f');
        }
      })
    }
  },
  methods: {
    create_interval: function(){
      const self = this
      let interval = 60000
      if(this.requestInterval != null) clearInterval(this.requestInterval)
      const query = { producerId: this.selected_producerId, groupId: this.selected_group }
      //if (this.current_page == "Substations") interval = 10000
      this.requestInterval = setInterval( () => { self.request_data(this.range, query, false) }, interval)
    },
    rangeBtnHandler: function(range){
      this.$store.commit('clear_data')
      this.range = range
      if (!this.range || !this.selected_producerId) return
      this.$store.dispatch('setRange', this.range)
      _paq.push(['trackEvent', this.current_page, 'Escala', this.range])
      const query = { producerId: this.selected_producerId, groupId: this.selected_group }
      if ((this.range == 'hour' || this.range == 'day')) this.create_interval() 
      else  clearInterval(this.requestInterval)
      
      if (this.current_page != "Substations") this.request_data(range, query, true)
    },
    isToday: function(){
      const timezone = this.$store.getters.timezone
      let datetime = $(`#datetime-picker`).data("DateTimePicker").date()  
      let datetimeUTC = moment.tz(datetime.format('YYYY-MM-DD'), timezone).toJSON()
      if (moment.tz(datetimeUTC, timezone).isSame(new Date(), "day")) return true
      return false
    },
    request_data: async function(range, query, loading=true){
      if (!range) return
      if (this.current_page == 'Substations') {
        this.$store.commit('clear_data')
        this.$store.commit('clear_current_data')
        const timezone = this.$store.getters.timezone
        let datetime = $(`#datetime-picker`).data("DateTimePicker").date() 
        if (!datetime) return  
        var datetimeUTC = moment.tz(datetime.format('YYYY-MM-DD'), timezone).toJSON() 
        clearInterval(this.requestInterval)
        //console.log("interval cleared")
        if ((this.range == 'hour' || this.range == 'day') && this.isToday()) this.create_interval()
        if (this.range == 'week') {
          if (datetime.day() == 0) datetimeUTC = moment.tz(datetime.day(-6).format("YYYY-MM-DD"), timezone).toJSON();
          else datetimeUTC = moment.tz(datetime.day(1).format("YYYY-MM-DD"), timezone).toJSON();
        }
        const query = { producerId: this.selected_producerId, groupId: this.selected_group }
        if (this.range == 'month') { 
          datetimeUTC = moment.tz(datetime.format('YYYY-MM'), timezone).toJSON()
          query.limit = true
        }
        this.$emit('queryChanged', query)
      }
      const group = this.groups.find(g => g._id == this.selected_group)
      //console.log("Dispatching action", this.selected_producerId, this.selected_group)
      this.$store.dispatch('request_single_data', { 
        range: this.range, 
        producerId: this.selected_producerId, 
        groupId: this.selected_group,
        batteries: group.bess || [],
        has_forecast: this.has_forecast,
        datetime: datetimeUTC || null,
        loading,
        samples: this.current_page == 'Substations' ? true : false
      })
    }
  },
  watch:{
    selected_producerId: function(){
      this.$store.commit('clear_data')
      this.$store.commit('clear_current_data')
      if (this.selected_producerId == '') return
      this.$store.commit('set_producerId', this.selected_producerId)

      let groups = null
      let selected_group = null
      if (this.$store.getters.user_isAdmin) {
        groups = this.$store.getters.remote_user_groups(this.selected_producerId)
        selected_group = this.$store.getters.remote_user_total_group_id(this.selected_producerId) || (groups.length ? groups[0]._id : null)
      } else {
        groups = this.$store.getters.user_groups
        selected_group = this.$store.getters.user_total_group_id
      }

      if (this.current_page == "Substations") {
        groups = groups.filter(g => g.hasOwnProperty('type') && g.type)
        selected_group = (groups.length ? groups[0]._id : null)
      }

      this.selected_group = selected_group
      this.groups = groups

      /* if (this.$store.getters.user_isAdmin) {
        this.groups = this.$store.getters.remote_user_groups(this.selected_producerId)  
        this.selected_group = this.$store.getters.remote_user_total_group_id(this.selected_producerId) || (this.groups.length ? this.groups[0]._id : null)
      }
      else {
        this.selected_group = this.$store.getters.user_total_group_id
        this.groups = this.$store.getters.user_groups
      } */
    },
    selected_group: function(){
      this.$store.commit('clear_data')
      this.$store.commit('clear_current_data')
      if (!this.selected_group || !this.selected_producerId) return
      let query = { producerId: this.selected_producerId, groupId: this.selected_group }
      this.$store.commit('set_groupId', this.selected_group)
      this.$store.dispatch('getFirstTimestamp', { producerId: this.selected_producerId, groupId: this.selected_group }).then((response) => {
        this.minDate = moment(new Date(response)).millisecond(0).second(0).minute(0).hour(0)
        if (this.current_page == "Substations") $(`#datetime-picker`).data("DateTimePicker").minDate(this.minDate)
      })
      if (this.range == 'hour' || this.range == 'day') this.create_interval()
      else clearInterval(this.requestInterval)
      if (this.current_page != "Substations" || !this.user_is_admin) { 
        this.request_data(this.range, query, true)
        this.$emit('queryChanged', query)
      }
    }, 
    range: {
      handler: function(after, before) {
        //_paq.push(['trackEvent', this.current_page, 'Escala', this.range])
        if (this.current_page == "Recent") return
        if (this.range == 'day' || this.range == 'week') {
          $(`#datetime-picker`).data("DateTimePicker").format('DD/MM/YYYY')
          $(`#datetime-picker`).data("DateTimePicker").viewMode('days')
          $(`#datetime-picker`).data("DateTimePicker").minDate(this.minDate)
          if (before != null) $(`#datetime-picker`).data("DateTimePicker").clear()
        } else if (this.range == 'month') {
          $(`#datetime-picker`).data("DateTimePicker").format('MM/YYYY')
          $(`#datetime-picker`).data("DateTimePicker").viewMode('months')
          $(`#datetime-picker`).data("DateTimePicker").minDate(moment(this.minDate).date(1) )
          $(`#datetime-picker`).data("DateTimePicker").clear()
        }
      }
    }
  },
  computed: {
    producers: function(){
      let producers = this.$store.getters.producers 
      if (this.current_page == "Substations")
        producers = producers.filter(p => p.groups.find(g => g.hasOwnProperty('type') && g.type == "substation"))
      return producers
    },
    user_is_admin: function(){
      return this.$store.getters.user_isAdmin
    },
    total_group_id: function(){
      if (this.$store.getters.user_isAdmin) return this.$store.getters.remote_user_total_group_id(this.$store.getters.selected_producerId)
      return this.$store.getters.user_total_group_id
    },
    has_forecast: function(){
      if (this.current_page == "Substations") return false
      if (this.$store.getters.user_isAdmin) return this.$store.getters.remote_user_forecast
      return this.$store.getters.user_forecast
    },
    current_page: function() {
      return this.$route.name
    }
  },
  destroyed: function(){
    clearInterval(this.requestInterval)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.button-border{
  border-color: 1px solid #8595ba;
}
.btn-range {
  color: #858796;
  background-color: #f0f1f4;
  border-color: #858796;
}
.btn-range:hover{
  background-color: #9294a3;
  color: #ffffff;
}
.btn-range.active{
  background-color: #89b43f;
  color: #ffffff;
}
.btn-range.active:hover{
  background-color: #1e986f;
  color: #ffffff;
}
</style>
